import atom, {getAtom, setAtom, useAtom} from "utils/atom";
import {SetStateAction} from "react";

const brandAtom = atom(0);

export const getBrandId = () => getAtom(brandAtom);

export const useBrandId = () => useAtom(brandAtom);

export const setBrandId = (brandId: SetStateAction<number>) =>
  setAtom(brandAtom, brandId);
